import { render, staticRenderFns } from "./InventoryModalKitsView.vue?vue&type=template&id=765c2bd9&scoped=true"
import script from "./InventoryModalKitsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryModalKitsView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765c2bd9",
  null
  
)

export default component.exports